import { render, staticRenderFns } from "./IdentifierChip.vue?vue&type=template&id=4dceb0f7"
import script from "./IdentifierChip.vue?vue&type=script&lang=js"
export * from "./IdentifierChip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports